import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.urnResource('stonecode_file_policy')
@doc.path('/stonecode_file_policies/{?id}')
@doc.timestampable
abstract class AbstractStonecodeFilePolicyModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		reference: Website_StonecodeFilePolicyReference;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
		reference: string;
	};

	@doc.string declare reference: Website_StonecodeFilePolicyReference;
}

interface AbstractStonecodeFilePolicyModel extends Timestampable {}

export default AbstractStonecodeFilePolicyModel;
